'use client'

import { OPEN_COOKIE_PREFERENCES_EVENT } from '@/components/CookieConsent'

// Opens the cookie-consent preferences overlay (footer "Cookies" link and
// the cookie policy page's "Manage cookies" button).

export function CookiePreferencesLink({
  className,
  children,
}: {
  className?: string
  children: React.ReactNode
}) {
  return (
    <button
      type="button"
      className={`cursor-pointer ${className ?? ''}`}
      onClick={() => window.dispatchEvent(new CustomEvent(OPEN_COOKIE_PREFERENCES_EVENT))}
    >
      {children}
    </button>
  )
}
